export const DOSAGE_PERIODS = [
    { text: 'MONTHLY', value: 'monthly' }, { text: 'WEEKLY', value: 'weekly' },
    { text: 'DAILY', value: 'daily' }, { text: 'HOURLY', value: 'hourly' },
    { text: 'AT_MEALTIMES', value: 'at_mealtimes' }, { text: 'OCCASIONAL', value: 'occasional' }
];

export const DAYS = [
    { text: 'MONDAY', value: 'mon' }, { text: 'TUESDAY', value: 'tue' },
    { text: 'WEDNESDAY', value: 'wed' }, { text: 'THURSDAY', value: 'thu' },
    { text: 'FRIDAY', value: 'fri' }, { text: 'SATURDAY', value: 'sat' },
    { text: 'SUNDAY', value: 'sun' }
];

export const DOSE_UNIT = { text: 'UNIT_MG', value: 'mg' };
